export enum METRICS {
	FT = 'ft',
	CM = 'cm',
	IN = 'in',
	LBS = 'lbs',
	KG = 'kg',
}
